{
  "title": "Model Families",
  "create": "Create",
  "modelFamilyName": "Model Family Name",
  "description": "Description",
  "core": "Core",
  "status": "Status",
  "states": {
    "draft": "Draft",
    "active": "Active",
    "archived": "Archived",
    "any": "Any"
  },
  "filters": {
    "search": "Search",
    "state": "Status",
    "core": "Core"
  },
  "coreFilter": {
    "any": "Any",
    "yes": "Yes",
    "no": "No"
  },
  "updateFamilyModal": {
    "title": "Update Model Family",
    "key": "Key",
    "name": "Name",
    "description": "Description",
    "shortDescription": "Short Description",
    "state": "State",
    "core": "Core",
    "icon": "Icon",
    "success": "Model family updated successfully",
    "error": "Failed to update model family",
    "transitionError": "Failed to update state",
    "unableToArchiveError": "Unable to archive. This Model Family is currently assigned to active portfolios.",
    "stateArchivedHint": "Archived model families cannot be changed to another status.",
    "rootPresetReadOnlyHint": "Root organization model families are preset for all users and cannot be edited."
  },
  "createFamilyModal": {
    "title": "Create Model Family",
    "key": "Key",
    "name": "Name",
    "description": "Description",
    "shortDescription": "Short Description",
    "core": "Core",
    "icon": "Icon",
    "success": "Model family created successfully",
    "error": "Failed to create model family"
  },
  "actions": {
    "edit": "Edit Model Family",
    "activate": "Activate Model Family",
    "draft": "Move to Draft",
    "archive": "Move to Archive"
  },
  "tabs": {
    "details": "Details",
    "auditLog": "Audit Log"
  }
}
